export const CardLoader = () => {
  return (
    <div className="flex justify-center items-center">
      <div className="card-loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-10 w-10"></div>
    </div>
  );
};
